// extracted by mini-css-extract-plugin
export default {"page":"styles_page__TqYgT","title":"styles_title__maFq2","subtitle":"styles_subtitle__m0LaG","text":"styles_text__vnShz","listItem":"styles_listItem__Hd0ci"};